<mbs-wizard
  class="mbs-wizard_flex-content"
  [buttonLoadingMode]="true"
  [canClosed]="!loading() && wizardFinish()"
  [loading]="loading()"
  [ngModel]="currentStep()"
  [saveButton]="{ text: ('shared:buttons.proceed' | i18next) }"
  [scrollableStepContent]="true"
  [stepsOrientation]="'vertical'"
  [title]="'wizards:ibbRestoreTypeWizard.title' | i18next"
  (ngModelChange)="currentStep.set($event)"
  (save)="handleSave()">
  <mbs-wizard-step
    [title]="'wizards:typeData.title' | i18next"
    [valid]="FormModel?.typeDataStep?.valid"
    (next)="typeDataStep?.forceValid(currentStep())">
    <mbs-type-data-step
      #typeDataStep
      [fileFormats]="FormModel.fileFormats"
      [(ngModel)]="FormModel.typeDataStep"></mbs-type-data-step>
  </mbs-wizard-step>

  @if (!isDRServerRestore) {
    <mbs-wizard-step
      [title]="'wizards:ibbRestoreTypeWizard.selectComputerStepTitle' | i18next"
      [valid]="FormModel?.selectTargetComputerStep?.valid">
      <mbs-select-target-computer-step
        [restoreAs]="FormModel.typeDataStep.restoreAs"
        [(value)]="FormModel.selectTargetComputerStep"></mbs-select-target-computer-step>
    </mbs-wizard-step>
  }
</mbs-wizard>
